export default __webpack_public_path__ + "static/cruiselines-vrc-ship-4-73736502070069b48ecd8a7019f7de52.jpg";